export {};

const config = {
    api: {
        url: "https://api.staywiserent.com",
    }
};

export default config; 